import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { AlertType } from './alert.model';
import { AlertService } from './alert.service';
var AlertComponent = /** @class */ (function () {
    function AlertComponent(router, alertService) {
        this.router = router;
        this.alertService = alertService;
        this.id = 'default-alert';
        this.fade = true;
        this.alerts = [];
    }
    AlertComponent.prototype.ngOnInit = function () {
        var _this = this;
        // subscribe to new alert notifications
        this.alertSubscription = this.alertService.onAlert(this.id)
            .subscribe(function (alert) {
            // clear alerts when an empty alert is received
            if (!alert.message) {
                // filter out alerts without 'keepAfterRouteChange' flag
                _this.alerts = _this.alerts.filter(function (x) { return x.keepAfterRouteChange; });
                // remove 'keepAfterRouteChange' flag on the rest
                _this.alerts.forEach(function (x) { return delete x.keepAfterRouteChange; });
                return;
            }
            // add alert to array
            _this.alerts.push(alert);
            // auto close alert if required
            if (alert.autoClose) {
                setTimeout(function () { return _this.removeAlert(alert); }, 3000);
            }
        });
        // clear alerts on location change
        this.routeSubscription = this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                _this.alertService.clear(_this.id);
            }
        });
    };
    AlertComponent.prototype.ngOnDestroy = function () {
        // unsubscribe to avoid memory leaks
        this.alertSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    };
    AlertComponent.prototype.removeAlert = function (alert) {
        var _this = this;
        // check if already removed to prevent error on auto close
        if (!this.alerts.includes(alert))
            return;
        if (this.fade) {
            // fade out alert
            this.alerts.find(function (x) { return x === alert; }).fade = true;
            // remove alert after faded out
            setTimeout(function () {
                _this.alerts = _this.alerts.filter(function (x) { return x !== alert; });
            }, 250);
        }
        else {
            // remove alert
            this.alerts = this.alerts.filter(function (x) { return x !== alert; });
        }
    };
    AlertComponent.prototype.cssClass = function (alert) {
        var _a;
        if (!alert)
            return;
        var classes = ['alert', 'alert-dismissable'];
        var alertTypeClass = (_a = {},
            _a[AlertType.Success] = 'alert alert-success',
            _a[AlertType.Error] = 'alert alert-danger',
            _a[AlertType.Info] = 'alert alert-info',
            _a[AlertType.Warning] = 'alert alert-warning',
            _a);
        classes.push(alertTypeClass[alert.type]);
        if (alert.fade) {
            classes.push('fade');
        }
        return classes.join(' ');
    };
    return AlertComponent;
}());
export { AlertComponent };
